import Type from "@/model/types/Type";

const type = {
    CREATED : 0,
    PENDING : 1,
    CURRENT : 2,
    DONE : 3,
    DELETED : 99,
}

const list = [
    {
        value: type.CREATED,
        text: "Criada",
    },
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.CURRENT,
        text: "Atual",
    },
    {
        value: type.DONE,
        text: "Finalizada",
    },
    {
        value: type.DELETED,
        text: "Excluída",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const hasDone = function(t) {
    return t === type.DONE || t === type.REPROVED
}

export default {
    type,
    list,
    contains,
    hasDone
}


